import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const { spacing, colors, typography } = THEME;

export const styles = StyleSheet.create({
	container: {
		padding: spacing.lg,
	},
	filtersContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.lg,
		padding: spacing.md,
		backgroundColor: '#ffffff',
		borderRadius: '8px',
		border: `1px solid ${colors.border.light}`,
	},
	title: {
		fontSize: typography.fontSizes.xl,
		color: colors.text.main,
	},
	filters: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	searchInput: {
		width: '300px !important',
		height: '36px !important',
		borderRadius: '6px !important',
		boxSizing: 'border-box',
	},
	conversationTypeFilter: {
		width: '200px',
	},
	statusFilter: {
		width: '130px',
	},
	emptyState: {
		textAlign: 'center',
		padding: spacing.xl,
		color: colors.text.light,
	},
	groupContainer: {
		marginBottom: spacing.xxl,
	},
	groupHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.lg,
		paddingBottom: spacing.md,
		borderBottom: `2px solid ${colors.border.light}`,
	},
	groupTitle: {
		fontSize: typography.fontSizes.xl,
		fontWeight: 600,
		color: colors.text.main,
		margin: 0,
	},
	groupMeta: {
		fontSize: typography.fontSizes.md,
		color: colors.text.light,
		fontWeight: 500,
	},
	dataGrid: {
		border: 'none !important',
		boxShadow: 'none !important',
	},
	templateRow: {
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.background.light,
		},
	},
	templateName: {
		color: colors.text.main,
		fontWeight: 500,
	},
	templateDescription: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.xs,
	},
	attachmentCount: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
	},
});
